<form class="container">
  <app-loader *ngIf="!learnset" [text]="'learnset.create_steps.edit_step.loading' | translate"></app-loader>
  <div class="flashcards-container">
    <span *ngIf="learnset" class="flashcard-count">{{learnset.flashcards.length}} Lernkarten erstellt</span>
    <app-flashcard-list *ngIf="learnset" [flashcards]="learnset.flashcards"></app-flashcard-list>
  </div>
</form>